import { useFormik } from 'formik'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import ModalComponent from '../../../../core/common/modal/ModalComponent'
import { useDeactivateUserToggleMutation, useUpdateLeadAssignToMutation } from '../../../../services/EndPointsApis'
import { all_routes } from '../../../router/all_routes'
import TextField from '../../../../core/common/textFields/TextField'
import Select, { StylesConfig } from "react-select";
import { svgIcons } from '../../../../style/fonts/SvgIcons'

type Props = {
    show: boolean
    handleClose: () => void
    formik?: any
    getallActiveUsers?: any
    refetch?: any
    TriggerteamsbyUser?: any
    getTeamsByUser?: any
    selectedIndividualCheckboxId?: any
}



const LeadProsAssignModal = ({ show, handleClose, getallActiveUsers, TriggerteamsbyUser, selectedIndividualCheckboxId, getTeamsByUser, refetch }: Props) => {
    const route = all_routes;
    const [updateLeadAssignTo, { data, isError, error, isSuccess, isLoading }] = useUpdateLeadAssignToMutation();
    const navigate = useNavigate();
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    const id = selectedIndividualCheckboxId
    const ProspectId = id[0];

    const handleSave = () => {
        formik.handleSubmit();
        formik.setFieldValue('leadProspectId',ProspectId)
    }
   

    const initialValues =
    {
        leadProspectId: '',
        lst_AssignedTo: {
            id: 0,
            value: ""
        },
    }
    const formik = useFormik({
        initialValues,
        onSubmit: (values, { resetForm }) => {

            updateLeadAssignTo({ ...values })

        },
    });
    const { resetForm } = formik;

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            handleClose();
            refetch()
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [isError, error]);

    return (
        <ModalComponent
            buttonText=""
            modalTitle='Assign Lead Prospect'
            onClose={handleClose}
            onSave={handleSave}
            isVisible={show}
            cancelButton="Cancel"
            saveButton='Assign'
        >
            <>
                <p className='mb-0 text-dark'>
                    You have selected one lead prospect.To whom would you like  <br /> to assign it ?
                </p>
                <div className="d-flex justify-content-between align-items-center mt-2">
                    <label className='input-label w-50'>Assign To</label>
                    <Select
                        styles={customStyles}
                        className="select w-50"
                        options={getallActiveUsers?.result?.map((option: any) => ({
                            label: option?.userName,
                            value: option?.userId
                        }))}
                        value={
                            formik.values?.lst_AssignedTo?.id
                                ? {
                                    value: formik.values?.lst_AssignedTo?.id,
                                    label: formik.values?.lst_AssignedTo?.value || '',
                                }
                                : null
                        }
                        // isDisabled={isReadOnly || disabledata}
                        onChange={(selectedOption: any) => {
                            TriggerteamsbyUser({ userId: selectedOption?.value })
                            formik.setFieldValue('lst_AssignedTo.id', selectedOption.value);
                            formik.setFieldValue('lst_AssignedTo.value', selectedOption.label);
                        }}
                    />
                </div>
                <div className="d-flex justify-content-between align-items-center mt-2">
                    <label className='input-label d-flex align-items-center gap-1 w-50'>
                        {svgIcons.LockIcon}Teams
                    </label>
                    <div className='col-md-12 br-gray p-2 w-50 h-teams overflow-auto'>
                        {getTeamsByUser?.result.map((teams: any) => (
                            <p key={teams.id} className='badge bg-soft-danger ms-2 '>
                                {teams.name}
                            </p>
                        ))}
                    </div>

                </div>
            </>

        </ModalComponent>
    )
}

export default LeadProsAssignModal